var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"flex justify-start"},[_c('div',{staticClass:"px-10 py-4 md:px-16"},[_c('div',{},[_c('div',{},[_c('h1',{staticClass:"font-black uppercase text-neutral-900"},[_vm._v("Store Component")])])])])])])
}]

export { render, staticRenderFns }